/* Carnima · Kaufführung Produktseite · 09.08.2026 (TODO-NEU-22, BEFUND-51)
   1) Einzelprodukte: Gebindeangabe neben den Preis stellen
   2) Einzelprodukte: Akkordeonzeile «Mindesthaltbarkeitsdatum» nur bei der Aktionscharge
   3) Vorteilspakete: Gebindeangabe entfernen (dort steht der Inhalt in der Beschreibung,
      «24 Dosen à 70 g» wäre bei 6 oder 10 Kartons falsch)
   4) Hinweiszeile in dieselbe Farbe wie die MHD-Zeile (Grösse stimmt bereits)

   Nicht mehr hier: Grundpreis und Produktangaben. Beide kommen aus dem Theme selbst
   – der Grundpreis aus snippets/price.liquid (Metafeld custom.netto_kg), die
   Produktangaben aus den Produktvorlagen. Vorlageninhalt und Ausgabe sollen
   dasselbe sagen; gerechnet wird serverseitig, damit die Angabe auch auf
   Kategorieseiten und ohne JavaScript steht.
   Diese Datei ordnet nur noch an: die Gebindeangabe wird vor den Grundpreis
   gesetzt, damit die Zeile «Preis · Gebinde · Grundpreis» lautet.

   Warum JavaScript: jedes Produkt hat eine eigene Vorlage mit eigenen Block-IDs,
   eine reine CSS-Lösung wäre pro Produkt anders.
   Kein Merker am Preiselement: Horizon ersetzt beim Variantenwechsel nur den
   Inhalt des Preisblocks – ein Attribut am Element überlebt, der Text nicht. */
(function () {
  'use strict';

  var GEBINDE = /\d+\s*(Dosen|Kartons)/i;

  function chargenauswahl() {
    return document.querySelectorAll('.variant-option--buttons input');
  }

  function produktbereich() {
    return document.querySelector('.product-information');
  }

  function kartons() {
    var m = document.getElementById('carnima-kartons');
    return m ? (parseInt(m.getAttribute('data-kartons'), 10) || 0) : 0;
  }

  function gebindeQuelle(bereich) {
    var kandidaten = bereich.querySelectorAll('.text-block strong');
    for (var i = 0; i < kandidaten.length; i++) {
      if (GEBINDE.test(kandidaten[i].textContent) && !kandidaten[i].closest('details')) {
        return kandidaten[i];
      }
    }
    return null;
  }

  function preiszeile() {
    var preise = document.querySelectorAll('product-price');
    for (var p = 0; p < preise.length; p++) {
      var preis = preise[p];

      var kinder = preis.children;
      var ziel = null;
      for (var k = kinder.length - 1; k >= 0; k--) {
        if (kinder[k].classList.contains('jdgm-widget')) continue;
        if (kinder[k].querySelector && kinder[k].querySelector('.jdgm-widget')) continue;
        ziel = kinder[k];
        break;
      }
      if (!ziel) continue;
      if (ziel.querySelector('.carnima-gebinde')) continue;

      var bereich = preis.closest('.product-information');
      var paket = bereich ? kartons() : 0;
      if (!bereich) bereich = document;

      var quelle = null;
      var text = '';
      if (paket > 0) {
        text = (paket * 24) + ' Dosen à 70 g';
      } else {
        quelle = gebindeQuelle(bereich);
        if (!quelle) continue;
        text = quelle.textContent.trim();
      }

      ziel.classList.add('carnima-preiszeile');

      var span = document.createElement('span');
      span.className = 'carnima-gebinde';
      span.textContent = text;

      /* Der Grundpreis kommt aus price.liquid und steht bereits im Kasten.
         Die Gebindeangabe gehört davor. */
      var grund = ziel.querySelector('.carnima-grundpreis');
      if (grund) {
        ziel.insertBefore(span, grund);
      } else {
        ziel.appendChild(span);
      }

      if (quelle) {
        var block = quelle.closest('.text-block');
        if (block) block.classList.add('carnima-verborgen');
      }
    }
  }

  function gebindeAufraeumen() {
    if (chargenauswahl().length) return;
    var bereich = produktbereich();
    if (!bereich) return;
    if (!/Kartons/i.test(bereich.textContent || '')) return;

    var quelle = gebindeQuelle(bereich);
    if (!quelle) return;
    var block = quelle.closest('.text-block');
    if (block) block.classList.add('carnima-verborgen');
  }

  function hinweiszeile() {
    var bereich = produktbereich();
    if (!bereich) return;
    var absaetze = bereich.querySelectorAll('.text-block p');
    for (var i = 0; i < absaetze.length; i++) {
      if (absaetze[i].classList.contains('carnima-hinweis')) continue;
      if (/^Hinweis:/.test((absaetze[i].textContent || '').trim())) {
        absaetze[i].classList.add('carnima-hinweis');
      }
    }
  }

  function mhdZeile() {
    var eingaben = chargenauswahl();
    if (!eingaben.length) return;

    var kenntAktion = false;
    var aktionAktiv = false;
    for (var i = 0; i < eingaben.length; i++) {
      if (/aktion/i.test(eingaben[i].value || '')) {
        kenntAktion = true;
        if (eingaben[i].checked) aktionAktiv = true;
      }
    }
    if (!kenntAktion) return;

    var titel = document.querySelectorAll('summary');
    for (var j = 0; j < titel.length; j++) {
      if (!/mindesthaltbarkeitsdatum/i.test(titel[j].textContent)) continue;
      var zeile = titel[j].closest('accordion-custom') || titel[j].closest('details');
      if (zeile) zeile.classList.toggle('carnima-verborgen', !aktionAktiv);
    }
  }

  var geplant = false;
  function lauf() {
    geplant = false;
    try { preiszeile(); } catch (e) {}
    try { gebindeAufraeumen(); } catch (e) {}
    try { hinweiszeile(); } catch (e) {}
    try { mhdZeile(); } catch (e) {}
  }
  function anstossen() {
    if (geplant) return;
    geplant = true;
    if (window.requestAnimationFrame) { window.requestAnimationFrame(lauf); } else { setTimeout(lauf, 16); }
  }

  document.addEventListener('change', anstossen, true);
  document.addEventListener('click', anstossen, true);
  if (window.MutationObserver) {
    new MutationObserver(anstossen).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', anstossen);
  }
  anstossen();
})();
